// Copyright (c) StrangeBee 2023

import { useGenericQuery } from '@Queries/genericQueries';
import { QueryKey, UseQueryResult } from 'react-query';
import { ParentController, QueryParams } from 'thehive-sdk';

interface UseListQueryParams {
    queryParams: QueryParams;
    controller: ParentController;
    fetchOnStart?: boolean;
    manual?: boolean;
}

const useListQuery = <T extends any[]>({
    queryParams,
    controller,
    fetchOnStart,
    manual,
}: UseListQueryParams): UseQueryResult<T, QueryKey> => {
    const {
        selector: { name },
        paginationOptions,
        sort,
        filters,
    } = queryParams;

    return useGenericQuery<T>({
        fetchCallback: () => controller.list<T>(queryParams),
        key: [name, paginationOptions?.page, paginationOptions?.itemsPerPage, filters, sort],
        fetchOnStart,
        manual,
    });
};

export default useListQuery;
